import { useTranslation } from 'react-i18next';
import Tabs from '../../../components/Tabs/Tabs';
import ReccuringTab from './ReccuringTab';
import SingleItemTab from './SingleItemTab';

const TABS = ['Single time', 'Recurring'];

export default function SellerServices() {
  const { t } = useTranslation();

  const renderContent = (activeTab: string | number) => {
    switch (activeTab) {
      case 'Recurring':
        return <ReccuringTab />;
      case 'Single time':
      default:
        return <SingleItemTab />;
    }
  };

  return (
    <div className='SellerServices Page flex-grow-1'>
      <div className='container'>
        <div className='Paper Paper--sm mx-auto p-4'>
          <div className='Text--30 fw-900 mb-3'>{t('Services')}</div>
          <Tabs tabs={TABS} renderContent={renderContent} />
        </div>
      </div>
    </div>
  );
}
